import { KeyboardEvent, RefObject } from "react"

import { BodyCellType, BodyRow } from "./types"
import { handleListRowKeyDown } from "../../../../hooks/useListKeyboardNavigation"

export function handleRowKeyDown(
  e: KeyboardEvent<HTMLTableRowElement>,
  row: BodyRow,
  searchInputRef: RefObject<HTMLInputElement | null>
) {
  const cell = row.cells.find(
    (c) =>
      c.type === BodyCellType.Checkbox || c.type === BodyCellType.RadioButton
  )
  handleListRowKeyDown(e, searchInputRef, {
    isClickable: !!row.onClick,
    onSpace: cell
      ? () => {
          if (cell.type === BodyCellType.RadioButton) {
            cell.onChangeIsChecked(true)
            return
          }
          cell.onChangeIsChecked({
            isChecked: !cell.isChecked,
            isShiftPressed: e.shiftKey,
          })
        }
      : undefined,
  })
}
